import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-renew-reactivate',
  templateUrl: './renew-reactivate.component.html',
  styleUrls: ['./renew-reactivate.component.scss'],
  imports: [IonButton, TranslateModule,FormsModule,CommonModule]
})
export class RenewReactivateComponent implements OnInit {

  @Input("paymentDescription") paymentDescription: string

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss()
  }
}
